import LoginPage from './LoginPage';
import loginReducer from './reducer';

export { loginReducer };
export default LoginPage;
